import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.99362 2.63471C5.6519 2.32228 5.098 2.32228 4.75629 2.63471C4.41457 2.94713 4.41457 3.45355 4.75629 3.76597L9.38772 8.00039L4.75629 12.2348C4.41457 12.5472 4.41457 13.0536 4.75629 13.3661C5.098 13.6785 5.6519 13.6785 5.99362 13.3661L11.2437 8.56602C11.5854 8.2536 11.5854 7.74718 11.2437 7.43476L5.99362 2.63471Z" }, null, -1)
  ]))]))
}
export default { render: render }